import { node } from "~/util/dom";
import createSDSIcon from "../icon";
import { CHECK_24 } from "~/util/sds-compatible-icons";
import { _ } from "~/i18n";

type TPlace = "buy-dialog" | "premium-status";
type TVersion = "version1" | "version2";

interface IOpts {
	place?: TPlace;
	version?: TVersion;
}

const version2 = [
	"premium.proposition.popup.privilege2.01",
	"profile.premiumStatus.privilege06",
	"premium.proposition.popup.privilege2.02",
	"premium.proposition.popup.privilege.02",
	"premium.proposition.popup.privilege2.03",
	"profile.premiumStatus.privilege05",
];
const sources: {[key in TVersion]: {
	[key2 in TPlace]: Array<string>;
}} = {
	version1: {
		"buy-dialog": [
			"premium.proposition.popup.privilege.01",
			"premium.proposition.popup.privilege.02",
			"premium.proposition.popup.privilege.03",
			"premium.proposition.popup.privilege.04",
			"premium.proposition.popup.privilege.05",
		],
		"premium-status": [
			"profile.premiumStatus.privilege01",
			"profile.premiumStatus.privilege02",
			"profile.premiumStatus.privilege03",
			"profile.premiumStatus.privilege04",
			"profile.premiumStatus.privilege05",
		],
	},
	version2: {
		"buy-dialog": version2,
		"premium-status": version2,
	},
};

export function createPrivileges({
	place = "buy-dialog",
	// TODO pri nasazeni mymaps dat novou verzi (hodinky, filtrace...)
	version = "version1",
}: IOpts) {
	// list vyhod premia
	const list = node("ul", { className: "premiumPrivileges" });
	const privilegesSort = sources[version][place];

	privilegesSort.forEach(privilege => {
		const item = node("li");
		const check = node("span", { className: "premiumPrivileges__check" });

		check.appendChild(createSDSIcon({ symbol: CHECK_24 }));
		item.append(check, node("span", { className: "premiumPrivileges__privilegeText" }, _(privilege)));

		list.appendChild(item);
	});

	return list;
}
